import { render, staticRenderFns } from "./ChatRedPacketBrief.vue?vue&type=template&id=005c1e95&scoped=true"
import script from "./ChatRedPacketBrief.vue?vue&type=script&lang=js"
export * from "./ChatRedPacketBrief.vue?vue&type=script&lang=js"
import style0 from "./ChatRedPacketBrief.vue?vue&type=style&index=0&id=005c1e95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c1e95",
  null
  
)

export default component.exports